import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase/client'
import { useUser } from '@/hooks/useAuth'

export type Membership = { villageId: string } | null

export function useMembership() {
  const user = useUser()

  return useQuery({
    queryKey: ['membership', user?.id],
    enabled: !!user,
    queryFn: async (): Promise<Membership> => {
      const { data, error } = await supabase
        .from('villagers')
        .select('village_id')
        .eq('user_id', user!.id)
        .order('joined_at', { ascending: true })
        .limit(1)
        .maybeSingle()
      if (error) throw error
      return data ? { villageId: data.village_id } : null
    },
    staleTime: Infinity,
    retry: 1,
  })
}
